import * as React from 'react';
import { AccordionItem } from './AccordionItem';
import '../../Assets/styles/accordion.css';
import { Text } from 'ilenia';
import { StyleSheet, css } from 'aphrodite';

export interface AccordionItemInterface {
    id: number;
    title: string | any;
    block: any;
}

interface AccordionState {
    activeId?: number;
}

interface AccordionProps {
    className?: string;
    title: string;
    data: AccordionItemInterface[];
    disabled: boolean;
}

export class Accordion extends React.Component<AccordionProps, AccordionState> {
    constructor(props: AccordionProps) {
        super(props);
        this.state = { activeId: undefined};
        this.handleClick = this.handleClick.bind(this);
    }

    public handleClick(id: number) {
        const activeId = this.state.activeId === id ? undefined : id;
        this.setState({ activeId });
    }

    public render() {
        const { activeId } = this.state;
        const { data, title, disabled } = this.props;
        return (
            <div className={css(styles.accordion, disabled && styles.disabled)} >
                <span className={css(styles.header)} >
                    <Text id={title} />
                </span>
                <ul className={css(styles.accordionList)}>
                    {data.map((elem: AccordionItemInterface) => {
                        return (
                            <li className={css(styles.item)} key={elem.id}>
                                <AccordionItem
                                    id={elem.id}
                                    opened={activeId === elem.id}
                                    element={elem.block}
                                    title={elem.title}
                                    handleClick={this.handleClick}
                                />
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    accordion: {
        width: '100%',
        paddingTop: '40px'
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.3,
    },
    header: {
        color: 'rgb(169, 169, 169)',
        fontSize: '14px',
        height: '17px',
        marginBottom: '36px',
        paddingLeft: '22px',
    },
    item: {
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    },
    accordionList: {
        listStyle: 'none',
        margin: '0',
        padding: '0',
        backgroundColor: '#fff',
        maxWidth: '718px',
        borderRadius: '0.4rem',
        paddingTop: '16px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    }
});
